/* eslint-disable max-len */
/* eslint-disable no-sequences */
import React, { useState } from 'react';
import classnames from 'classnames';
import { useValueChange } from '@leverege/ui-hooks';
import { ModelTypeSelector } from '@leverege/ui-plugin';
import { Colorizers } from '@leverege/ui-attributes';
import { TabPane, IdGen, Pane, Label, NumericInput, TextInput, Checkbox, Popup, Text } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import CapSelector from "../../shared/views/CapSelector.js";
import JoinSelector from "../../shared/views/JoinSelector.js";
import LineStyleSelector from "../../shared/views/LineStyleSelector.js";
import Model from "./GeoShapeModel.js";
import S from './Grid.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('molten.dataViewers.map.GeoShapeEditor');
function GeoShapeEditor(props) {
  const {
    value
  } = props;
  const onModelChange = useValueChange(Model, props);
  const [ids] = useState(IdGen.createIds('gse', 55));
  let cid = 0;
  if (value == null) {
    return null;
  }
  const objectType = Model.getObjectType(value);
  return /*#__PURE__*/_jsxs(TabPane, {
    children: [/*#__PURE__*/_jsx(TabPane.Tab, {
      tabName: t('visibility'),
      tabId: "vis",
      children: /*#__PURE__*/_jsxs(Pane, {
        variant: "editor",
        className: S.grid,
        children: [/*#__PURE__*/_jsx(Checkbox, {
          id: ids[cid++],
          containerClassName: S.fill,
          label: t('visible'),
          eventData: "setVisible",
          value: Model.getVisible(value),
          onChange: onModelChange
        }), /*#__PURE__*/_jsxs("div", {
          className: classnames(S.sub, S.grid),
          children: [/*#__PURE__*/_jsx(Label, {
            variant: "input",
            htmlFor: ids[cid],
            children: t('showZoom')
          }), /*#__PURE__*/_jsx(NumericInput, {
            id: ids[cid++],
            eventData: "setShowAtZoom",
            min: 0,
            max: Math.min(25, Model.getHideAtZoom(value)),
            allowError: true,
            value: Model.getShowAtZoom(value),
            onChange: onModelChange
          }, `haz-${Model.getHideAtZoom(value) || 'n'}`), /*#__PURE__*/_jsx(Label, {
            variant: "input",
            htmlFor: ids[cid],
            children: t('hideZoom')
          }), /*#__PURE__*/_jsx(NumericInput, {
            id: ids[cid++],
            min: Math.max(0, Model.getShowAtZoom(value)),
            max: 25,
            eventData: "setHideAtZoom",
            allowError: true,
            value: Model.getHideAtZoom(value),
            onChange: onModelChange
          }, `saz-${Model.getShowAtZoom(value) || 'n'}`), /*#__PURE__*/_jsx(Label, {
            variant: "input",
            htmlFor: ids[cid],
            children: t('fadeInOutZoom')
          }), /*#__PURE__*/_jsx(NumericInput, {
            id: ids[cid++],
            min: 0,
            max: 10,
            eventData: "setFadeZoom",
            allowError: true,
            float: true,
            value: Model.getFadeZoom(value),
            onChange: onModelChange
          })]
        }), /*#__PURE__*/_jsx(Popup, {
          title: t('help'),
          icon: tIcon('helpIcon', 'fa fa-question-circle fa-fw'),
          children: /*#__PURE__*/_jsxs("div", {
            className: S.pad,
            children: [/*#__PURE__*/_jsx(Text, {
              className: classnames(S.fill, S.hint),
              variant: "caption",
              children: t('settingZoomDescription')
            }), /*#__PURE__*/_jsx(Text, {
              className: S.fill,
              variant: "subtitle",
              children: t('zoomLevel')
            }), /*#__PURE__*/_jsxs("div", {
              className: S.grid,
              style: {
                columnGap: 'var( --size-padXLarge, 32px)'
              },
              children: [/*#__PURE__*/_jsx("span", {
                children: "0"
              }), /*#__PURE__*/_jsx("span", {
                children: t('0Zoom')
              }), /*#__PURE__*/_jsx("span", {
                children: "3"
              }), /*#__PURE__*/_jsx("span", {
                children: t('3Zoom')
              }), /*#__PURE__*/_jsx("span", {
                children: "4"
              }), /*#__PURE__*/_jsx("span", {
                children: t('4Zoom')
              }), /*#__PURE__*/_jsx("span", {
                children: "6"
              }), /*#__PURE__*/_jsx("span", {
                children: t('6Zoom')
              }), /*#__PURE__*/_jsx("span", {
                children: "10"
              }), /*#__PURE__*/_jsx("span", {
                children: t('10Zoom')
              }), /*#__PURE__*/_jsx("span", {
                children: "15"
              }), /*#__PURE__*/_jsx("span", {
                children: t('15Zoom')
              }), /*#__PURE__*/_jsx("span", {
                children: "18"
              }), /*#__PURE__*/_jsx("span", {
                children: t('18Zoom')
              })]
            })]
          })
        }), /*#__PURE__*/_jsx(Text, {
          className: S.fill,
          variant: "subtitle",
          children: t('interaction')
        }), /*#__PURE__*/_jsxs("div", {
          className: classnames(S.grid, S.fill, S.sub),
          children: [/*#__PURE__*/_jsx(Checkbox, {
            id: ids[cid++],
            containerClassName: S.fill,
            label: t('rollover'),
            eventData: "setRolloverable",
            value: Model.getRolloverable(value),
            onChange: onModelChange
          }), /*#__PURE__*/_jsx(Checkbox, {
            id: ids[cid++],
            containerClassName: S.fill,
            label: t('selectable'),
            eventData: "setSelectable",
            value: Model.getSelectable(value),
            onChange: onModelChange
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: classnames(S.sub, S.grid),
          children: [/*#__PURE__*/_jsx(Label, {
            variant: "input",
            htmlFor: ids[cid],
            children: t('startInteractionAtZoom')
          }), /*#__PURE__*/_jsx(NumericInput, {
            id: ids[cid++],
            eventData: "setStartInteractionAtZoom",
            min: 0,
            max: Math.min(25, Model.getStartInteractionAtZoom(value)),
            allowError: true,
            value: Model.getStartInteractionAtZoom(value),
            onChange: onModelChange
          }, `stiaz-${Model.getStopInteractionAtZoom(value) || 'n'}`), /*#__PURE__*/_jsx(Label, {
            variant: "input",
            htmlFor: ids[cid],
            children: t('stopInteractionAtZoom')
          }), /*#__PURE__*/_jsx(NumericInput, {
            id: ids[cid++],
            min: Math.max(0, Model.getStartInteractionAtZoom(value)),
            max: 25,
            eventData: "setStopInteractionAtZoom",
            allowError: true,
            value: Model.getStopInteractionAtZoom(value),
            onChange: onModelChange
          }, `spiaz-${Model.getStartInteractionAtZoom(value) || 'n'}`)]
        })]
      })
    }), /*#__PURE__*/_jsx(TabPane.Tab, {
      tabName: t('appearance'),
      tabId: "app",
      children: /*#__PURE__*/_jsxs(Pane, {
        variant: "editor",
        className: S.grid,
        children: [/*#__PURE__*/_jsx(Text, {
          className: S.fill,
          variant: "subtitle",
          children: t('fill')
        }), /*#__PURE__*/_jsxs(Pane, {
          variant: "editor",
          className: classnames(classnames(S.sub, S.fill, S.grid)),
          children: [/*#__PURE__*/_jsx(Label, {
            htmlFor: ids[cid],
            children: t('color')
          }), ModelTypeSelector.createSelectorAndEditor({
            editorProps: {
              ...props,
              objectType,
              id: ids[cid++]
            },
            modelKey: 'colorizer',
            values: Colorizers.getColorizersFor(objectType),
            value: Model.getFillColor(value),
            eventData: 'setFillColor',
            onChange: onModelChange
          }, S.fill), /*#__PURE__*/_jsx(Label, {
            variant: "input",
            htmlFor: ids[cid],
            children: t('opacity')
          }), /*#__PURE__*/_jsx(NumericInput, {
            id: ids[cid++],
            min: 0,
            max: 1,
            float: true,
            eventData: "setFillOpacity",
            allowError: true,
            value: Model.getFillOpacity(value),
            onChange: onModelChange
          }), /*#__PURE__*/_jsx(Label, {
            variant: "input",
            htmlFor: ids[cid],
            children: t('pattern')
          }), /*#__PURE__*/_jsx(TextInput, {
            id: ids[cid++],
            eventData: "setFillPattern",
            allowError: true,
            value: Model.getFillPattern(value),
            onChange: onModelChange
          })]
        }), /*#__PURE__*/_jsx(Text, {
          className: S.fill,
          variant: "subtitle",
          children: t('outline')
        }), /*#__PURE__*/_jsxs(Pane, {
          variant: "editor",
          className: classnames(S.sub, S.fill, S.grid),
          children: [/*#__PURE__*/_jsx(Label, {
            htmlFor: ids[cid],
            children: t('width')
          }), /*#__PURE__*/_jsx(NumericInput, {
            id: ids[cid++],
            min: 0,
            max: 50,
            float: true,
            eventData: "setLineWidth",
            allowError: true,
            value: Model.getLineWidth(value),
            onChange: onModelChange
          }), /*#__PURE__*/_jsx(Label, {
            htmlFor: ids[cid],
            children: t('color')
          }), ModelTypeSelector.createSelectorAndEditor({
            editorProps: {
              ...props,
              objectType,
              id: ids[cid++]
            },
            modelKey: 'colorizer',
            values: Colorizers.getColorizersFor(objectType),
            value: Model.getLineColor(value),
            eventData: 'setLineColor',
            onChange: onModelChange
          }, S.fill), /*#__PURE__*/_jsx(Label, {
            variant: "input",
            htmlFor: ids[cid],
            children: t('opacity')
          }), /*#__PURE__*/_jsx(NumericInput, {
            id: ids[cid++],
            min: 0,
            max: 1,
            float: true,
            eventData: "setLineOpacity",
            allowError: true,
            value: Model.getLineOpacity(value),
            onChange: onModelChange
          }), /*#__PURE__*/_jsx(Label, {
            htmlFor: ids[cid],
            children: t('style')
          }), /*#__PURE__*/_jsx(LineStyleSelector, {
            id: ids[cid++],
            value: Model.getLineStyle(value),
            eventData: "setLineStyle",
            onChange: onModelChange
          }), Model.getLineStyle(value) === 'pattern' && /*#__PURE__*/_jsxs(React.Fragment, {
            children: [/*#__PURE__*/_jsx(Label, {
              variant: "input",
              htmlFor: ids[cid],
              children: t('pattern')
            }), /*#__PURE__*/_jsx(TextInput, {
              id: ids[cid++],
              eventData: "setLinePattern",
              allowError: true,
              value: Model.getLinePattern(value),
              onChange: onModelChange
            })]
          }), /*#__PURE__*/_jsx(Label, {
            variant: "input",
            htmlFor: ids[cid],
            children: t('cap')
          }), /*#__PURE__*/_jsx(CapSelector, {
            eventData: "setLineCap",
            value: Model.getLineCap(value) || 'butt',
            onChange: onModelChange
          }), /*#__PURE__*/_jsx(Label, {
            variant: "input",
            htmlFor: ids[cid],
            children: t('join')
          }), /*#__PURE__*/_jsx(JoinSelector, {
            eventData: "setLineJoin",
            value: Model.getLineJoin(value) || 'miter',
            onChange: onModelChange
          })]
        }), /*#__PURE__*/_jsx(Text, {
          className: S.fill,
          variant: "subtitle",
          children: t('label')
        }), /*#__PURE__*/_jsx(Checkbox, {
          containerClassName: S.fill,
          label: t('visible'),
          value: Model.getLabelVisible(value),
          onChange: onModelChange,
          eventData: "setLabelVisible"
        }), /*#__PURE__*/_jsxs(Pane, {
          variant: "editor",
          className: classnames(S.sub, S.fill, S.grid),
          children: [/*#__PURE__*/_jsx(Label, {
            variant: "input",
            htmlFor: ids[cid],
            children: t('attribute')
          }), /*#__PURE__*/_jsx(TextInput, {
            id: ids[cid++],
            size: 24,
            eventData: "setLabelAttribute",
            allowError: true,
            value: Model.getLabelAttribute(value),
            onChange: onModelChange
          }), /*#__PURE__*/_jsx(Label, {
            variant: "input",
            htmlFor: ids[cid],
            children: t('attributeLine2')
          }), /*#__PURE__*/_jsx(TextInput, {
            id: ids[cid++],
            size: 24,
            eventData: "setLabelAttribute2",
            allowError: true,
            value: Model.getLabelAttribute2(value),
            onChange: onModelChange
          }), /*#__PURE__*/_jsx(Label, {
            htmlFor: ids[cid],
            children: t('color')
          }), ModelTypeSelector.createSelectorAndEditor({
            editorProps: {
              ...props,
              objectType,
              id: ids[cid++]
            },
            modelKey: 'colorizer',
            values: Colorizers.getColorizersFor(objectType),
            value: Model.getLabelColor(value),
            eventData: 'setLabelColor',
            onChange: onModelChange
          }, S.fill), /*#__PURE__*/_jsx(Label, {
            htmlFor: ids[cid],
            children: t('size')
          }), /*#__PURE__*/_jsx(NumericInput, {
            id: ids[cid++],
            min: 0,
            max: 50,
            float: true,
            eventData: "setLabelSize",
            allowError: true,
            value: Model.getLabelSize(value),
            onChange: onModelChange
          }), /*#__PURE__*/_jsx(Label, {
            variant: "input",
            htmlFor: ids[cid],
            children: t('opacity')
          }), /*#__PURE__*/_jsx(NumericInput, {
            id: ids[cid++],
            min: 0,
            max: 1,
            float: true,
            eventData: "setLabelOpacity",
            allowError: true,
            value: Model.getLabelOpacity(value),
            onChange: onModelChange
          }), /*#__PURE__*/_jsx(Label, {
            variant: "input",
            htmlFor: ids[cid],
            children: t('line2Scale')
          }), /*#__PURE__*/_jsx(NumericInput, {
            id: ids[cid++],
            min: 0,
            max: 4,
            float: true,
            eventData: "setLabelAttribute2Scale",
            allowError: true,
            value: Model.getLabelAttribute2Scale(value),
            onChange: onModelChange
          }), /*#__PURE__*/_jsxs(Pane, {
            variant: "editor",
            className: classnames(S.sub, S.fill, S.grid),
            children: [/*#__PURE__*/_jsx(Text, {
              className: S.fill,
              variant: "subtitle",
              children: t('labelCollision')
            }), /*#__PURE__*/_jsx(Checkbox, {
              containerClassName: S.fill,
              label: t('allowOverlap'),
              title: t('allowOverlapDescription'),
              value: Model.getAllowOverlap(value),
              onChange: onModelChange,
              eventData: "setAllowOverlap"
            }), /*#__PURE__*/_jsx(Checkbox, {
              containerClassName: S.fill,
              label: t('ignorePlacement'),
              title: t('ignorePlacementDescription'),
              value: Model.getIgnorePlacement(value),
              onChange: onModelChange,
              eventData: "setIgnorePlacement"
            })]
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(TabPane.Tab, {
      tabName: t('rollover'),
      tabId: "rollover",
      children: conditionAppearance('Rollover', onModelChange, value, objectType, props)
    }), /*#__PURE__*/_jsx(TabPane.Tab, {
      tabName: t('selected'),
      tabId: "selected",
      children: conditionAppearance('Selected', onModelChange, value, objectType, props)
    })]
  });
}
function conditionAppearance(prefix, onModelChange, value, objectType, props) {
  const omc = onModelChange;
  const shfc = `setHas${prefix}FillColor`;
  const shfo = `setHas${prefix}FillOpacity`;
  const shfp = `setHas${prefix}FillPattern`;
  const shlw = `setHas${prefix}LineWidth`;
  const shls = `setHas${prefix}LineStyle`;
  const shlc = `setHas${prefix}LineColor`;
  const shlo = `setHas${prefix}LineOpacity`;
  const sfc = `set${prefix}FillColor`;
  const sfo = `set${prefix}FillOpacity`;
  const sfp = `set${prefix}FillPattern`;
  const slw = `set${prefix}LineWidth`;
  const slc = `set${prefix}LineColor`;
  const slo = `set${prefix}LineOpacity`;
  const sls = `set${prefix}LineStyle`;
  const slp = `set${prefix}LinePattern`;
  const slcp = `set${prefix}LineCap`;
  const slj = `set${prefix}LineJoin`;
  const stv = `set${prefix}LabelVisible`;
  const stc = `set${prefix}LabelColor`;
  const sts = `set${prefix}LabelSize`;
  const sto = `set${prefix}LabelOpacity`;
  const sta = `set${prefix}LabelAttribute`;
  const sta2 = `set${prefix}LabelAttribute2`;
  const stas2 = `set${prefix}LabelAttribute2Scale`;
  const sao = `set${prefix}AllowOverlap`;
  const sip = `set${prefix}IgnorePlacement`;
  const gfc = Model[`get${prefix}FillColor`](value);
  const gfo = Model[`get${prefix}FillOpacity`](value);
  const gfp = Model[`get${prefix}FillPattern`](value);
  const glw = Model[`get${prefix}LineWidth`](value);
  const glc = Model[`get${prefix}LineColor`](value);
  const glo = Model[`get${prefix}LineOpacity`](value);
  const gls = Model[`get${prefix}LineStyle`](value);
  const glp = Model[`get${prefix}LinePattern`](value);
  const glcp = Model[`get${prefix}LineCap`](value);
  const glj = Model[`get${prefix}LineJoin`](value);
  const gao = `get${prefix}AllowOverlap`;
  const gip = `get${prefix}IgnorePlacement`;
  const hfc = Model[`getHas${prefix}FillColor`](value);
  const hfo = Model[`getHas${prefix}FillOpacity`](value);
  const hfp = Model[`getHas${prefix}FillPattern`](value);
  const hlw = Model[`getHas${prefix}LineWidth`](value);
  const hls = Model[`getHas${prefix}LineStyle`](value);
  const hlc = Model[`getHas${prefix}LineColor`](value);
  const hlo = Model[`getHas${prefix}LineOpacity`](value);
  const hlcp = Model[`getHas${prefix}LineCap`](value);
  const hlj = Model[`getHas${prefix}LineJoin`](value);
  const gtv = Model[`get${prefix}LabelVisible`](value);
  const gtc = Model[`get${prefix}LabelColor`](value);
  const gto = Model[`get${prefix}LabelOpacity`](value);
  const gta = Model[`get${prefix}LabelAttribute`](value);
  const gta2 = Model[`get${prefix}LabelAttribute2`](value);
  const gtas2 = Model[`get${prefix}LabelAttribute2Scale`](value);
  const gts = Model[`get${prefix}LabelSize`](value);
  const htv = Model[`getHas${prefix}LabelVisible`](value);
  const htc = Model[`getHas${prefix}LabelColor`](value);
  const hto = Model[`getHas${prefix}LabelOpacity`](value);
  const hta = Model[`getHas${prefix}LabelAttribute`](value);
  const hta2 = Model[`getHas${prefix}LabelAttribute2`](value);
  const htas2 = Model[`getHas${prefix}LabelAttribute2Scale`](value);
  const hts = Model[`getHas${prefix}LabelSize`](value);
  const shtv = `setHas${prefix}LabelVisible`;
  const shtc = `setHas${prefix}LabelColor`;
  const shto = `setHas${prefix}LabelOpacity`;
  const shta = `setHas${prefix}LabelAttribute`;
  const shta2 = `setHas${prefix}LabelAttribute2`;
  const shtas2 = `setHas${prefix}LabelAttribute2Scale`;
  const shts = `setHas${prefix}LabelSize`;
  return /*#__PURE__*/_jsxs(Pane, {
    variant: "editor",
    className: S.grid,
    children: [/*#__PURE__*/_jsx(Text, {
      className: S.fill,
      variant: "subtitle",
      children: t('fill')
    }), /*#__PURE__*/_jsxs(Pane, {
      variant: "editor",
      className: classnames(S.sub, S.fill, S.grid),
      children: [/*#__PURE__*/_jsx(Checkbox, {
        label: t('color'),
        value: hfc,
        onChange: omc,
        eventData: shfc
      }), !hfc ? /*#__PURE__*/_jsx("div", {}) : ModelTypeSelector.createSelectorAndEditor({
        editorProps: {
          ...props,
          objectType
        },
        modelKey: 'colorizer',
        values: Colorizers.getColorizersFor(objectType),
        value: gfc,
        eventData: sfc,
        onChange: omc
      }, S.fill), /*#__PURE__*/_jsx(Checkbox, {
        label: t('opacity'),
        value: hfo,
        onChange: omc,
        eventData: shfo
      }), !hfo ? /*#__PURE__*/_jsx("div", {}) : /*#__PURE__*/_jsx(NumericInput, {
        min: 0,
        max: 1,
        float: true,
        eventData: sfo,
        allowError: true,
        value: gfo,
        onChange: omc
      }), /*#__PURE__*/_jsx(Checkbox, {
        label: t('pattern'),
        value: hfp,
        onChange: omc,
        eventData: shfp
      }), !hfp ? /*#__PURE__*/_jsx("div", {}) : /*#__PURE__*/_jsx(TextInput, {
        eventData: sfp,
        value: gfp,
        onChange: omc
      })]
    }), /*#__PURE__*/_jsx(Text, {
      className: S.fill,
      variant: "subtitle",
      children: t('outline')
    }), /*#__PURE__*/_jsxs(Pane, {
      variant: "editor",
      className: classnames(S.sub, S.fill, S.grid),
      children: [/*#__PURE__*/_jsx(Checkbox, {
        label: "Width",
        value: hlw,
        onChange: omc,
        eventData: shlw
      }), !hlw ? /*#__PURE__*/_jsx("div", {}) : /*#__PURE__*/_jsx(NumericInput, {
        min: 0,
        max: 50,
        float: true,
        eventData: slw,
        allowError: true,
        value: glw,
        onChange: omc
      }), /*#__PURE__*/_jsx(Checkbox, {
        label: t('color'),
        value: hlc,
        onChange: omc,
        eventData: shlc
      }), !hlc ? /*#__PURE__*/_jsx("div", {}) : ModelTypeSelector.createSelectorAndEditor({
        editorProps: {
          ...props,
          objectType
        },
        modelKey: 'colorizer',
        values: Colorizers.getColorizersFor(objectType),
        value: glc,
        eventData: slc,
        onChange: omc
      }, S.fill), /*#__PURE__*/_jsx(Checkbox, {
        label: t('opacity'),
        value: hlo,
        onChange: omc,
        eventData: shlo
      }), !hlo ? /*#__PURE__*/_jsx("div", {}) : /*#__PURE__*/_jsx(NumericInput, {
        min: 0,
        max: 1,
        float: true,
        eventData: slo,
        allowError: true,
        value: glo,
        onChange: omc
      }), /*#__PURE__*/_jsx(Checkbox, {
        label: t('style'),
        value: hls,
        onChange: omc,
        eventData: shls
      }), !hls ? /*#__PURE__*/_jsx("div", {}) : /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx(LineStyleSelector, {
          value: gls,
          eventData: sls,
          onChange: omc
        }), gls === 'pattern' && /*#__PURE__*/_jsxs("div", {
          className: classnames(S.grid, S.fill, S.sub),
          children: [/*#__PURE__*/_jsx(Label, {
            variant: "input",
            children: t('pattern')
          }), /*#__PURE__*/_jsx(TextInput, {
            eventData: slp,
            allowError: true,
            value: glp,
            onChange: omc
          })]
        })]
      }), /*#__PURE__*/_jsx(Checkbox, {
        label: t('cap'),
        value: hlcp,
        onChange: omc,
        eventData: `setHas${prefix}LineCap`
      }), !hlcp ? /*#__PURE__*/_jsx("div", {}) : /*#__PURE__*/_jsx(CapSelector, {
        eventData: slcp,
        value: glcp || 'butt',
        onChange: omc
      }), /*#__PURE__*/_jsx(Checkbox, {
        label: t('join'),
        value: hlj,
        onChange: omc,
        eventData: `setHas${prefix}LineJoin`
      }), !hlj ? /*#__PURE__*/_jsx("div", {}) : /*#__PURE__*/_jsx(JoinSelector, {
        eventData: slj,
        value: glj || 'miter',
        onChange: omc
      })]
    }), /*#__PURE__*/_jsx(Text, {
      className: S.fill,
      variant: "subtitle",
      children: t('label')
    }), /*#__PURE__*/_jsxs(Pane, {
      variant: "editor",
      className: classnames(S.sub, S.fill, S.grid),
      children: [/*#__PURE__*/_jsx(Checkbox, {
        label: t('overrideVisible'),
        value: htv,
        onChange: omc,
        eventData: shtv
      }), !htv ? /*#__PURE__*/_jsx("div", {}) : /*#__PURE__*/_jsx(Checkbox, {
        label: "Visible",
        value: gtv,
        onChange: omc,
        eventData: stv
      }), /*#__PURE__*/_jsx(Checkbox, {
        label: t('attribute'),
        value: hta,
        onChange: omc,
        eventData: shta
      }), !hta ? /*#__PURE__*/_jsx("div", {}) : /*#__PURE__*/_jsx(TextInput, {
        size: 24,
        eventData: sta,
        value: gta,
        onChange: omc
      }), /*#__PURE__*/_jsx(Checkbox, {
        label: t('attributeLine2'),
        value: hta2,
        onChange: omc,
        eventData: shta2
      }), !hta2 ? /*#__PURE__*/_jsx("div", {}) : /*#__PURE__*/_jsx(TextInput, {
        size: 24,
        eventData: sta2,
        value: gta2,
        onChange: omc
      }), /*#__PURE__*/_jsx(Checkbox, {
        label: t('color'),
        value: htc,
        onChange: omc,
        eventData: shtc
      }), !htc ? /*#__PURE__*/_jsx("div", {}) : ModelTypeSelector.createSelectorAndEditor({
        editorProps: {
          ...props,
          objectType
        },
        modelKey: 'colorizer',
        values: Colorizers.getColorizersFor(objectType),
        value: gtc,
        eventData: stc,
        onChange: omc
      }, S.fill), /*#__PURE__*/_jsx(Checkbox, {
        label: t('size'),
        value: hts,
        onChange: omc,
        eventData: shts
      }), !hts ? /*#__PURE__*/_jsx("div", {}) : /*#__PURE__*/_jsx(NumericInput, {
        min: 0,
        max: 50,
        float: true,
        eventData: sts,
        allowError: true,
        value: gts,
        onChange: omc
      }), /*#__PURE__*/_jsx(Checkbox, {
        label: t('opacity'),
        value: hto,
        onChange: omc,
        eventData: shto
      }), !hto ? /*#__PURE__*/_jsx("div", {}) : /*#__PURE__*/_jsx(NumericInput, {
        min: 0,
        max: 1,
        float: true,
        eventData: sto,
        allowError: true,
        value: gto,
        onChange: omc
      }), /*#__PURE__*/_jsx(Checkbox, {
        label: t('line2Scale'),
        value: htas2,
        onChange: omc,
        eventData: shtas2
      }), !htas2 ? /*#__PURE__*/_jsx("div", {}) : /*#__PURE__*/_jsx(NumericInput, {
        min: 0,
        max: 4,
        float: true,
        eventData: stas2,
        allowError: true,
        value: gtas2,
        onChange: omc
      }), /*#__PURE__*/_jsxs(Pane, {
        variant: "editor",
        className: classnames(S.sub, S.fill, S.grid),
        children: [/*#__PURE__*/_jsx(Text, {
          className: S.fill,
          variant: "subtitle",
          children: t('labelCollision')
        }), /*#__PURE__*/_jsx(Checkbox, {
          label: t('allowOverlap'),
          value: gao,
          onChange: omc,
          eventData: sao
        }), /*#__PURE__*/_jsx(Checkbox, {
          label: t('ignorePlacement'),
          value: gip,
          onChange: omc,
          eventData: sip
        })]
      })]
    })]
  });
}
export default /*#__PURE__*/React.memo(GeoShapeEditor);